/** @jsx jsx */

import { FormattedMessage } from 'react-intl';
import { jsx } from '@emotion/core';

import { Icon } from '@zapier/zinnia-icons';
import { Colors, Grid, Text } from '@zapier/design-system';

import Dismiss from 'app/developer-v3/components/Dismiss';
import Link from 'app/common/components/Link';
import { PARTNER_EMAIL_ADDRESS } from 'app/developer-v3/constants';

import Styles from '../CTAVersioning.styles';

type Props = {
  completedZapsCount: number;
  helpLinks: React.ReactNode;
  onDismiss: () => void;
};

function MigrationDone(props: Props) {
  const { completedZapsCount, helpLinks, onDismiss } = props;

  return (
    <div css={Styles.root(Colors.StatusSuccessWeakest)}>
      <Grid columns="30px auto 20px" gap={20}>
        <Icon color="StatusSuccess" name="formCheckCircle" size={30} />
        <div>
          <Text fontWeight={600} tag="h2" type="Body4">
            <FormattedMessage
              defaultMessage="Update complete"
              id="headings-update-complete"
            />
          </Text>
          <Text margin="10px 0px 0px" tag="p">
            <FormattedMessage
              defaultMessage="{count, plural, one {We updated # Zap.} other {We updated # Zaps.}} {helpLinks} If you notice any issues, contact us at <component0>{partnerEmailAddress}</component0>."
              id="messages-updated-zaps-help-and-contact"
              values={{
                count: completedZapsCount,
                helpLinks,
                partnerEmailAddress: PARTNER_EMAIL_ADDRESS,
                component0: chunks => (
                  <Link href={`mailto:${PARTNER_EMAIL_ADDRESS}`}>{chunks}</Link>
                ),
              }}
            />
          </Text>
        </div>
        <Dismiss onDismiss={onDismiss} />
      </Grid>
    </div>
  );
}

export default MigrationDone;
